import { propOr } from 'ramda';
import { JackpotType, JackpotWin, TotalJackpotType } from '../../../types';
import { useInHouseJackpotsStore } from '../../store';

const selectAllJackpotsIds = () => propOr([], 'ids');
const selectTotalJackpot = () => propOr({}, 'totalJackpot');
const selectJackpotWin = () => propOr(null, 'jackpotWin');

export const useAllJackpotsIds = (): JackpotType[] =>
  useInHouseJackpotsStore<JackpotType[]>(selectAllJackpotsIds());

export const useTotalJackpot = (): TotalJackpotType =>
  useInHouseJackpotsStore<TotalJackpotType>(selectTotalJackpot());

export const useGetJackpotWin = (): JackpotWin | null =>
  useInHouseJackpotsStore<JackpotWin | null>(selectJackpotWin());
